/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Gpdeclinesubreasonrequired5Inputs */

const en_coinvestments_declinedeal_gpdeclinesubreasonrequired5 = /** @type {(inputs: Coinvestments_Declinedeal_Gpdeclinesubreasonrequired5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a sub-reason`)
};

/**
* | output |
* | --- |
* | "Please select a sub-reason" |
*
* @param {Coinvestments_Declinedeal_Gpdeclinesubreasonrequired5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_gpdeclinesubreasonrequired5 = /** @type {((inputs?: Coinvestments_Declinedeal_Gpdeclinesubreasonrequired5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Gpdeclinesubreasonrequired5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_gpdeclinesubreasonrequired5(inputs)
});
export { coinvestments_declinedeal_gpdeclinesubreasonrequired5 as "coInvestments_declineDeal_gpDeclineSubreasonRequired" }